export const fuelEmptyData = () => ({
    cost: {
        fossil: {
            electricity: 0,
            gasoline: 0,
            diesel: 0,
            total: 0,
        },
        electric: {
            electricity: 0,
            gasoline: 0,
            diesel: 0,
            total: 0,
            rateInfo: {},
        },
    },
    savings: {
        total: 0,
    },
});
export const emissionsEmptyData = () => ({
    emissions: {
        fossil: {
            gasoline: {
                emissions: 0,
                volume: 0,
            },
            diesel: {
                emissions: 0,
                volume: 0,
            },
            totalEmissions: 0,
            totalVolume: 0,
        },
        electricity: {
            emissions: 0,
            inLbsPerMwh: 0,
        },
        treesPlanted: 0,
    },
});
export const INITIAL_RESULTS_STATE = {
    status: {
        fuel: {
            isReady: false,
        },
        incentives: {
            isReady: false,
        },
        emissions: {
            isReady: false,
        },
        chargers: {
            isReady: false,
        },
        operations: {
            isReady: false,
        },
        vehicles: {
            isReady: false,
        },
        profile: {
            isReady: false,
        },
        calculations: {
            isReady: false,
        },
        inputs: {
            isReady: false,
        },
        rateEngine: {
            isReady: false,
        },
    },
    total: {
        annual: {
            fuel: undefined,
            incentives: undefined,
            emissions: undefined,
            chargers: undefined,
            operations: undefined,
            vehicles: undefined,
            profile: undefined,
        },
        cumulative: undefined,
        yearly: undefined,
    },
    perSet: undefined,
};
